function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M10 5a1 1 0 110 2c-1.448 0-3 1.552-3 3a1 1 0 11-2 0c0-2.552 2.448-5 5-5zM12 17a1 1 0 010-2c1.448 0 3-1.552 3-3a1 1 0 012 0c0 2.552-2.448 5-5 5z"
}));

var SvgSmall = function SvgSmall(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22
    }, props), _ref)
  );
};

export default SvgSmall;